import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-b41f00ee")

_pushScopeId("data-v-b41f00ee")
const _hoisted_1 = {
  key: 0,
  class: "admin-contract-user-item admin-header"
}
const _hoisted_2 = /*#__PURE__*/_createVNode("div", { class: "email" }, "ユーザーID", -1)
const _hoisted_3 = /*#__PURE__*/_createVNode("div", { class: "name" }, "氏名", -1)
const _hoisted_4 = /*#__PURE__*/_createVNode("div", { class: "commands" }, null, -1)
const _hoisted_5 = {
  key: 1,
  class: "admin-contract-user-item admin-item"
}
const _hoisted_6 = { class: "email" }
const _hoisted_7 = { class: "name" }
const _hoisted_8 = { class: "commands" }
const _hoisted_9 = /*#__PURE__*/_createVNode("span", null, "編集", -1)
const _hoisted_10 = /*#__PURE__*/_createVNode("span", null, "削除", -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("div", null, [
    (_ctx.isHeader)
      ? (_openBlock(), _createBlock("div", _hoisted_1, [
          _hoisted_2,
          _hoisted_3,
          _hoisted_4
        ]))
      : _createCommentVNode("", true),
    (!_ctx.isHeader)
      ? (_openBlock(), _createBlock("div", _hoisted_5, [
          _createVNode("div", _hoisted_6, _toDisplayString(_ctx.item.email), 1),
          _createVNode("div", _hoisted_7, _toDisplayString(_ctx.item.name), 1),
          _createVNode("div", _hoisted_8, [
            _createVNode("button", {
              class: "primary-button",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.context.emit('edit', _ctx.item)))
            }, [
              _hoisted_9
            ]),
            _createVNode("button", {
              class: "danger-button",
              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.context.emit('danger', _ctx.item)))
            }, [
              _hoisted_10
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
})